import React, { useEffect, useState } from "react";
import bgButtonActive from "../../../../../assets/images/Mini-Game/bg-tab-active-popup.png";
import bgButton from "../../../../../assets/images/Mini-Game/bg-tab-popup.png";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "../../../../../utils/hooks";
import { Pagination, Table } from "antd";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import styled from "styled-components";
import { getDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";
import moment from "moment";
import _ from "lodash";
import iconRankTop1 from "../../../../../assets/images/Mini-Game/number-1.png";
import iconRankTop2 from "../../../../../assets/images/Mini-Game/rank-top-2.png";
import iconRankTop3 from "../../../../../assets/images/Mini-Game/rank-top-3.png";
import iconRule from "../../../../../assets/images/Mini-Game/icon-rule.png";

export default function ComponentInviteUser() {
  const isMobile = useMediaQuery(`(max-width: 486px)`);
  const { t } = useTranslation();

  const [tabActive, setTabActive] = useState(1);
  const [isShowPopupRule, setIsShowPopupRule] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataTable, setDataTable] = useState({});
  const [dataMe, setDataMe] = useState([]);

  const handleRankingImage = (index) => {
    switch (index) {
      case 1:
        return (
          <img src={iconRankTop1} alt="rank-top-1" className="ranking-icon" />
        );
      case 2:
        return (
          <img src={iconRankTop2} alt="rank-top-2" className="ranking-icon" />
        );
      case 3:
        return (
          <img src={iconRankTop3} alt="rank-top-3" className="ranking-icon" />
        );
      default:
        return <span className="rank-num rank-num__minigame">{index}</span>; // For other ranks, just display the index + 1
    }
  };

  useEffect(() => {
    if (tabActive === 1) {
      let timer;
      const fetchData = async () => {
        setIsLoader(true);
        const urlApi = API_PATH.miniGameInviteRanking;
        const data = await getDataApi(urlApi);
        let convertData = { ...data };

        if (!_.isEmpty(data?.data)) {
          const sourtData = data?.data.sort((a, b) => a.rnk - b.rnk);
          const newData = sourtData.map((item, index) => {
            const srcImg = handleRankingImage(+item.rnk);
            return {
              ...item,
              srcImg,
            };
          });

          const dataMe = newData.filter((item) => item.its_me);
          convertData.data = newData;
          setDataMe(dataMe);
        }

        setDataTable(convertData || []);

        timer = setTimeout(() => {
          setIsLoader(false);
        }, 400);
      };

      fetchData();

      return () => clearTimeout(timer);
    }
  }, [tabActive]);

  useEffect(() => {
    if (tabActive !== 1) {
      let timer;
      const fetchData = async () => {
        setIsLoader(true);
        const data = await getDataApi(
          `${API_PATH.miniGameWinnerInviteRanking}?page=${currentPage}&limit=10`
        );
        if (data?.data) {
          const newData = data?.data.map((item) => {
            return {
              ...item,
              cycle: `${moment(item.start_time).format(
                "DD/MM/YYYY"
              )} - ${moment(item.end_time).format("DD/MM/YYYY")}`,
            };
          });

          setDataTable({ ...data, data: newData });
        }
        timer = setTimeout(() => {
          setIsLoader(false);
        }, 400);
      };
      fetchData();
    }
  }, [currentPage, tabActive]);

  const dataTab = [
    {
      id: 1,
      content: t("mini_game.pop_up_ranking.ranking"),
    },
    {
      id: 2,
      content: t("mini_game.pop_up_ranking.winner"),
    },
  ];

  const handleChangeTabs = (id) => {
    setTabActive(id);
    setCurrentPage(1);
  };
  const highlightRow = (record) => {
    return +record.its_me === 1 ? "highlight-row" : "";
  };

  if (isShowPopupRule) {
    const renderRanking = t("mini_game.pop_up_rule.invite_leaderboard_rules", {
      returnObjects: true,
    });
    const dataArrayRanking = Object.entries(renderRanking).map(
      ([section, value]) => ({
        section,
        ...value,
      })
    );

    return (
      <Container>
        <>
          <div className="header-mini-popup-rule">
            <img src={bgHeader} alt="" className="img-rule-mini" />
            <div className="content-rule-mini content-rule-ranking">
              Invite လုပ်ပြီး ဆုရရှိရန် စည်းကမ်းများ{" "}
            </div>
          </div>
          <div className="box-content-minigame-popup__container box-content-minigame-popup__scroll">
            <div className="box-content-minigame-popup">
              {dataArrayRanking.map((item, index) => {
                return (
                  <div
                    className="container-minigame-popup-ranking"
                    key={`ranking_${index}`}
                  >
                    <div className="title-popup-mini sub-title">
                      {/* {item?.title} */}
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.title }}
                      />
                    </div>
                    <div className="container-content-rule-mini">
                      <div className="mini-rule-popup-content">
                        <div
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                        {/* {item.content} */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      </Container>
    );
  }

  return (
    <Container>
      <div className="mini-tab-popup">
        {dataTab.map((item) => (
          <div
            onClick={() => handleChangeTabs(item.id)}
            key={item.id}
            className={`position-relative tab-mini-popup ${
              item.id === tabActive ? "tab-popup-active" : ""
            }`}
          >
            <img
              src={item.id === tabActive ? bgButtonActive : bgButton}
              alt=""
              style={{ minHeight: "50px" }}
            />
            <div className="tab-popup__content">{item.content}</div>
          </div>
        ))}
      </div>

      <>
        <div className="header-mini-popup-rule">
          <img src={bgHeader} alt="" className="img-rule-mini" />
          <div className="content-rule-mini">Invite Ranking</div>
          <img
            src={iconRule}
            onClick={() => setIsShowPopupRule(true)}
            alt=""
            className="icon-rule-minigame scale-hover-item"
          />
        </div>
        {tabActive === 1 ? (
          <>
            <Table
              className="table-winner"
              dataSource={dataTable?.data?.slice(
                (currentPage - 1) * 10,
                currentPage * 10
              )}
              loading={isLoader}
              pagination={false}
              scroll={{
                y: !_.isEmpty(dataMe) ? 300 : 365,
              }}
              rowClassName={highlightRow}
            >
              <Table.Column
                title={t("mini_game.pop_up_ranking.no")}
                dataIndex="srcImg"
                key="key"
                align="center"
                width={isMobile ? "20%" : "15%"}
              />

              <Table.Column
                title={t("event_thingyan.pop_up.isdn")}
                dataIndex="isdn_referral"
                key="isdn_referral"
                width={isMobile ? "35%" : "40%"}
              />

              <Table.Column
                title={"သူငယ်ချင်းအရေအတွက်"}
                dataIndex="num"
                key="num"
                width={isMobile ? "45%" : "40%"}
                render={(num) => {
                  return (
                    <>
                      <div>{num}</div>
                    </>
                  );
                }}
              />
            </Table>
            {!_.isEmpty(dataMe) ? (
              <div className="minigame-rank-me">
                <Table
                  className="table-winner"
                  dataSource={dataMe}
                  pagination={false}
                  rowClassName={highlightRow}
                  showHeader={false}
                >
                  <Table.Column
                    title={t("mini_game.pop_up_ranking.no")}
                    dataIndex="srcImg"
                    key="key"
                    align="center"
                    width={isMobile ? "20%" : "15%"}
                  />

                  <Table.Column
                    title={t("event_thingyan.pop_up.isdn")}
                    dataIndex="isdn_referral"
                    key="isdn_referral"
                    width={isMobile ? "35%" : "40%"}
                  />

                  <Table.Column
                    title={t("mini_game.pop_up_ranking.number_of_pieces")}
                    dataIndex="num"
                    key="num"
                    width={isMobile ? "45%" : "40%"}
                    render={(num) => {
                      return (
                        <>
                          <div style={{ marginLeft: "-5px" }}>{num}</div>
                        </>
                      );
                    }}
                  />
                </Table>
              </div>
            ) : (
              <></>
            )}

            <div
              className={`pagination-popup-his__mini-game ${
                _.isEmpty(dataMe) ? "mt-page-20" : ""
              }`}
            >
              <Pagination
                current={currentPage}
                pageSize={10}
                total={dataTable?.data?.length || 0}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
                itemRender={(page, type, originalElement) => {
                  if (type === "prev") {
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        className="action-table-mini-game"
                      >
                        ←{" "}
                        <span className="action-table-mini-game-content">
                          {t("mini_game.pop_up_activity_history.prev")}
                        </span>
                      </span>
                    );
                  }
                  if (type === "next") {
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        className="action-table-mini-game"
                      >
                        <span className="action-table-mini-game-content">
                          {t("mini_game.pop_up_activity_history.next")}
                        </span>{" "}
                        →
                      </span>
                    );
                  }
                  return originalElement;
                }}
              />
            </div>
          </>
        ) : (
          <div>
            <Table
              className="table-winner"
              dataSource={dataTable?.data}
              loading={isLoader}
              pagination={false}
              scroll={{
                y: 365,
              }}
              rowClassName={highlightRow}
            >
              <Table.Column
                title={"အနိုင်ရရှိသူ"}
                dataIndex="isdn"
                key="isdn"
                align="center"
                width={isMobile ? "35%" : "30%"}
              />

              <Table.Column
                title={"Cycle"}
                dataIndex="cycle"
                key="cycle"
                width={isMobile ? "40%" : "30%"}
              />

              <Table.Column
                title={t("mini_game.pop_up_ranking.number_of_friends")}
                dataIndex="number_of_friend"
                key="number_of_friend"
                width={isMobile ? "25%" : "40%"}
                render={(number_of_friend) => {
                  return <div>{number_of_friend?.num || 0}</div>;
                }}
              />
            </Table>

            <div
              className="pagination-popup-his__mini-game"
              style={{ marginTop: "20px" }}
            >
              <Pagination
                current={currentPage}
                pageSize={10}
                total={dataTable?.total || 0}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
                itemRender={(page, type, originalElement) => {
                  if (type === "prev") {
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        className="action-table-mini-game"
                      >
                        ←{" "}
                        <span className="action-table-mini-game-content">
                          {t("mini_game.pop_up_activity_history.prev")}
                        </span>
                      </span>
                    );
                  }
                  if (type === "next") {
                    return (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        className="action-table-mini-game"
                      >
                        <span className="action-table-mini-game-content">
                          {t("mini_game.pop_up_activity_history.next")}
                        </span>{" "}
                        →
                      </span>
                    );
                  }
                  return originalElement;
                }}
              />
            </div>
          </div>
        )}
      </>
    </Container>
  );
}

const Container = styled.div`
  .table-winner .ant-table-body::-webkit-scrollbar-button {
    display: none;
  }

  .box-content-minigame-popup__container.box-content-minigame-popup__scroll {
    max-height: inherit !important;
    padding-right: 0px !important;
    overflow-y: auto !important;
  }

  .title-popup-mini.sub-title {
    font-size: 16px;
  }

  .mini-rule-popup-content {
    font-size: 13px;
  }

  .icon-rule-minigame {
    position: absolute;
    top: 30px;
    right: -27px;
    cursor: pointer;
  }

  .mt-page-20 {
    margin-top: 20px;
  }

  .mini-tab-popup {
    margin-bottom: 15px;
  }

  .minigame-rank-me {
    margin: 20px 0;
    .table-winner .ant-table-tbody > tr > td {
      background-color: #fdd7bc !important;
    }
    table {
      border: 1px solid white !important;
      border-radius: 10px;
      overflow: hidden;

      .ant-table-tbody > tr > td {
        border-bottom: 0px !important;
      }
    }
  }

  .table-winner .ant-table-body {
    scrollbar-width: thin;
    scrollbar-color: #ccc transparent;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-button {
    display: none;
  }

  .table-winner .ant-table-body::-webkit-scrollbar {
    width: 6px;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-track {
    background: transparent;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-thumb {
    background-color: #bbb;
    border-radius: 5px;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-button {
    display: none;
  }

  @media (max-width: 576px) {
    .ant-table-wrapper .ant-table-thead > tr > th,
    .ant-table-wrapper .ant-table-tbody > tr > td {
      padding: 12px 4px;
    }

    .icon-rule-minigame {
      right: 0;
    }

  }
  .ranking-icon {
    height: 25px;
  }

  @media (max-width: 400px) {
    .icon-rule-minigame {
      right: 8%;
    }
  }
`;
